<template>
    <Paper :header="$t('tests.assessmentModule.header')">
        <div
            v-for="test in tests"
            :key="test.key"
            class="test-item clickable"
            @click="() => toTest(test)"
        >
            <div class="test-item-content p-4">
                <div>
                    <div class="image-wrapper">
                        <img class="image" :src="test.img" />
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <h5>{{ test.title }}</h5>
                    <p class="caption mute">{{ test.description }}</p>
                </div>
                <div
                    v-if="!test.comingSoon"
                    class="test-item-action d-flex align-items-center h-100"
                >
                    <BaseButton variant="primary" class="w-100">
                        {{ test.actionLabel }}
                    </BaseButton>
                </div>
            </div>
            <Divider />

            <ComingSoon v-if="test.comingSoon" />
        </div>
    </Paper>
</template>

<script>
import ComingSoon from './ComingSoon';

export default {
    name: 'Assessment',
    components: { ComingSoon },
    props: {
        tests: {
            type: Array, // Objects,
            required: true,
        },
    },
    methods: {
        toTest(testObject) {
            if (!testObject.comingSoon) {
                this.$router.push(this.$URLS.tests.concat('/', testObject.url));
            }
        },
    },
};
</script>

<style scoped>
.test-item {
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.test-item-content {
    display: grid;
    grid-template-columns: 100px auto 100px;
    grid-template-areas: 'image text action';
    grid-gap: 12px;
}

.test-item-action {
    grid-area: action;
}

.image-wrapper {
    max-width: 100px;
    max-height: 100px;
}
.image {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
}

@media only screen and (max-width: 600px) {
    .test-item-content {
        grid-template-columns: 100px auto;
        grid-template-areas:
            'image text'
            'action action';
    }
}
</style>
